import { render, staticRenderFns } from "./StatisticsChannelDetails.vue?vue&type=template&id=5de27aab&"
import script from "./StatisticsChannelDetails.vue?vue&type=script&lang=js&"
export * from "./StatisticsChannelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports